// Static list of cartridges and their abbreviations for selectors and display
// Source: User-provided list from SAAMI PDFs (Active Cartridges and Chambers)

export const CARTRIDGES = [
  { id: 1, value: '17 Mach 2', abbrev: '17 M 2' },
  { id: 2, value: '17 Hornady Magnum Rimfire', abbrev: '17 HMR' },
  { id: 3, value: '17 Winchester Super Magnum', abbrev: '17 Win Super Mag' },
  { id: 4, value: '22 Short', abbrev: '22 S' },
  { id: 5, value: '22 Long', abbrev: '22 L' },
  { id: 6, value: '22 Long Rifle', abbrev: '22 LR' },
  { id: 7, value: '22 Winchester Rimfire', abbrev: '22 WRF' },
  { id: 8, value: '22 Winchester Magnum (Rimfire) *', abbrev: '22 WMR' },
  { id: 9, value: '9mm Luger', abbrev: '9mm Luger' },
  { id: 10, value: '9mm Luger +P', abbrev: '9mm Luger +P *' },
  { id: 11, value: '9x18 Makarov', abbrev: '9x18 Mak' },
  { id: 12, value: '9x23 Winchester', abbrev: '9x23 Win' },
  { id: 13, value: '10mm Automatic', abbrev: '10mm Auto' },
  { id: 14, value: '221 Remington Fireball', abbrev: '221 Rem Fireball' },
  { id: 15, value: '25 Automatic', abbrev: '25 Auto' },
  { id: 16, value: '30 Luger (7.65mm)', abbrev: '30 Luger (7.65mm)' },
  { id: 17, value: '32 Automatic', abbrev: '32 Auto' },
  { id: 18, value: '32 H&R Magnum', abbrev: '32 H&R Mag' },
  { id: 19, value: '32 Smith & Wesson', abbrev: '32 S&W' },
  { id: 20, value: '32 Smith & Wesson Long', abbrev: '32 S&WL' },
  { id: 21, value: '327 Federal Magnum', abbrev: '327 Fed Mag' },
  { id: 22, value: '357 Magnum', abbrev: '357 Mag' },
  { id: 23, value: '357 Sig', abbrev: '357 Sig' },
  { id: 24, value: '38 Automatic', abbrev: '38 Auto' },
  { id: 25, value: '38 Smith & Wesson', abbrev: '38 S&W' },
  { id: 26, value: '38 Special', abbrev: '38 Spl' },
  { id: 27, value: '38 Special Match', abbrev: '38 Spl Match' },
  { id: 28, value: '38 Special +P', abbrev: '38 Spl +P *' },
  { id: 29, value: '38 Super Automatic +P', abbrev: '38 Super Auto +P*' },
  { id: 30, value: '380 Automatic', abbrev: '380 Auto' },
  { id: 31, value: '40 Smith & Wesson', abbrev: '40 S&W' },
  { id: 32, value: '41 Remington Magnum', abbrev: '41 Rem Mag' },
  { id: 33, value: '429 Desert Eagle', abbrev: '429 DE' },
  { id: 34, value: '44 Remington Magnum', abbrev: '44 Rem Mag' },
  { id: 35, value: '44 Smith & Wesson Special', abbrev: '44 S&W Spl' },
  { id: 36, value: '45 Automatic', abbrev: '45 Auto' },
  { id: 37, value: '45 Automatic Match', abbrev: '45 Auto Match' },
  { id: 38, value: '45 Automatic +P', abbrev: '45 Auto +P*' },
  { id: 39, value: '45 Colt', abbrev: '45 Colt' },
  { id: 40, value: '45 Glock Automatic Pistol', abbrev: '45 GAP' },
  { id: 41, value: '45 Winchester Magnum', abbrev: '45 Win Mag' },
  { id: 42, value: '454 Casull', abbrev: '454 Casull' },
  { id: 43, value: '460 S&W Magnum', abbrev: '460 S&W Mag' },
  { id: 44, value: '475 Linebaugh', abbrev: '475 Linebaugh' },
  { id: 45, value: '480 Ruger', abbrev: '480 Ruger' },
  { id: 46, value: '50 Action Express', abbrev: '50 AE' },
  { id: 47, value: '500 S&W Magnum', abbrev: '500 S&W Mag' },
  { id: 48, value: '6mm Advanced Rifle Cartridge', abbrev: '6mm ARC' },
  { id: 49, value: '6mm Creedmoor', abbrev: '6mm CM' },
  { id: 50, value: '6mm GT', abbrev: '6mm GT' },
  { id: 51, value: '6mm Remington', abbrev: '6mm REM' },
  { id: 52, value: '6.5 Creedmoor', abbrev: '6.5 CM' },
  { id: 53, value: '6.5 Grendel', abbrev: '6.5 GREN' },
  { id: 54, value: '6.5 Precision Rifle Cartridge', abbrev: '6.5 PRC' },
  { id: 55, value: '6.5 Weatherby Rebated Precision Magnum', abbrev: '6.5 WBY RPM' },
  { id: 56, value: '6.5-284 Norma', abbrev: '6.5-284' },
  { id: 57, value: '6.5-300 Weatherby Magnum', abbrev: '6.5-300 WBY MAG' },
  { id: 58, value: '6.5x55 Swedish', abbrev: '6.5x55' },
  { id: 59, value: '6.8 True Velocity Composite', abbrev: '6.8 TVC' },
  { id: 60, value: '6.8 Western', abbrev: '6.8 WESTERN' },
  { id: 61, value: '6.8mm Remington SPC', abbrev: '6.8mm REM SPC' },
  { id: 62, value: '7mm Mauser (7x57)', abbrev: '7mm (7x57)' },
  { id: 63, value: '7mm Precision Rifle Cartridge', abbrev: '7mm PRC' },
  { id: 64, value: '7mm Remington Magnum', abbrev: '7mm REM MAG' },
  { id: 65, value: '7mm Remington Short Action Ultra Magnum', abbrev: '7mm REM SA ULTRA MAG' },
  { id: 66, value: '7mm Remington Ultra Magnum', abbrev: '7mm REM ULTRA MAG' },
  { id: 67, value: '7mm Weatherby Magnum', abbrev: '7mm WBY MAG' },
  { id: 68, value: '7mm Winchester Short Magnum', abbrev: '7mm WSM' },
  { id: 69, value: '7mm-08 Remington', abbrev: '7mm-08 REM' },
  { id: 70, value: '7 x 64 Brenneke', abbrev: '7x64' },
  { id: 71, value: '7.62 x 39', abbrev: '7.62x39' },
  { id: 72, value: '8mm Mauser (8x57)', abbrev: '8mm (8x57)' },
  { id: 73, value: '9.3 x 62', abbrev: '9.3 x 62' },
  { id: 74, value: '17 Hornet', abbrev: '17 HORNET' },
  { id: 75, value: '17 Remington', abbrev: '17 REM' },
  { id: 76, value: '17 Remington Fireball', abbrev: '17 REM FIREBALL' },
  { id: 77, value: '204 Ruger', abbrev: '204 RUGER' },
  { id: 78, value: '218 Bee', abbrev: '218 BEE' },
  { id: 79, value: '22 Advanced Rifle Cartridge', abbrev: '22 ARC' },
  { id: 80, value: '22 Creedmoor', abbrev: '22 CM' },
  { id: 81, value: '22 Hornet', abbrev: '22 HORNET' },
  { id: 82, value: '22 Nosler', abbrev: '22 NOSLER' },
  { id: 83, value: '22-250 Remington', abbrev: '22-250 REM' },
  { id: 84, value: '220 Swift', abbrev: '220 SWIFT' },
  { id: 85, value: '221 Remington Fireball', abbrev: '221 REM FIREBALL' },
  { id: 86, value: '222 Remington', abbrev: '222 REM' },
  { id: 87, value: '222 Remington Magnum', abbrev: '222 REM MAG' },
  { id: 88, value: '223 Remington', abbrev: '223 REM' },
  { id: 89, value: '223 Winchester Super Short Magnum', abbrev: '223 WSSM' },
  { id: 90, value: '224 Valkyrie', abbrev: '224 VLK' },
  { id: 91, value: '243 Winchester', abbrev: '243 WIN' },
  { id: 92, value: '243 Winchester Super Short Magnum', abbrev: '243 WSSM' },
  { id: 93, value: '25 Winchester Super Short Magnum', abbrev: '25 WSSM' },
  { id: 94, value: '25-06 Remington', abbrev: '25-06 REM' },
  { id: 95, value: '25-20 Winchester', abbrev: '25-20 WIN' },
  { id: 96, value: '25-35 Winchester', abbrev: '25-35 WIN' },
  { id: 97, value: '250 Savage', abbrev: '250 SAV' },
  { id: 98, value: '257 Roberts', abbrev: '257 ROB' },
  { id: 99, value: '257 Roberts +P', abbrev: '257 ROB +P *' },
  { id: 100, value: '257 Weatherby Magnum', abbrev: '257 WBY MAG' },
  { id: 101, value: '26 Nosler', abbrev: '26 NOSLER' },
  { id: 102, value: '260 Remington', abbrev: '260 REM' },
  { id: 103, value: '264 Winchester Magnum', abbrev: '264 WIN MAG' },
  { id: 104, value: '27 Nosler', abbrev: '27 NOSLER' },
  { id: 105, value: '270 Weatherby Magnum', abbrev: '270 WBY MAG' },
  { id: 106, value: '270 Winchester', abbrev: '270 WIN' },
  { id: 107, value: '270 Winchester Short Magnum', abbrev: '270 WSM' },
  { id: 108, value: '277 SIG Fury', abbrev: '277 SIG FURY' },
  { id: 109, value: '28 Nosler', abbrev: '28 NOSLER' },
  { id: 110, value: '280 Ackley Improved', abbrev: '280 ACK IMP' },
  { id: 111, value: '280 Remington', abbrev: '280 REM' },
  { id: 112, value: '284 Winchester', abbrev: '284 WIN' },
  { id: 113, value: '30 Carbine', abbrev: '30 CARB' },
  { id: 114, value: '30 Nosler', abbrev: '30 NOSLER' },
  { id: 115, value: '30 Remington AR', abbrev: '30 REM AR' },
  { id: 116, value: '30 Thompson Center', abbrev: '30 TC' },
  { id: 117, value: '30-06 Springfield', abbrev: '30-06 SPRG' },
  { id: 118, value: '30-30 Winchester', abbrev: '30-30 WIN' },
  { id: 119, value: '30-40 Krag', abbrev: '30-40 KRAG' },
  { id: 120, value: '300 AAC Blackout', abbrev: '300 BLK' },
  { id: 121, value: '300 HAM’R', abbrev: '300 HAMR' },
  { id: 122, value: '300 Holland & Holland Magnum', abbrev: '300 H&H MAG' },
  { id: 123, value: '300 Norma Magnum', abbrev: '300 NM' },
  { id: 124, value: '300 Precision Rifle Cartridge', abbrev: '300 PRC' },
  { id: 125, value: '300 Remington Short Action Ultra Magnum', abbrev: '300 REM SA ULTRA MAG' },
  { id: 126, value: '300 Remington Ultra Magnum', abbrev: '300 REM ULTRA MAG' },
  { id: 127, value: '300 Ruger Compact Magnum', abbrev: '300 RCM' },
  { id: 128, value: '300 Savage', abbrev: '300 SAV' },
  { id: 129, value: '300 Weatherby Magnum', abbrev: '300 WBY MAG' },
  { id: 130, value: '300 Winchester Magnum', abbrev: '300 WIN MAG' },
  { id: 131, value: '300 Winchester Short Magnum', abbrev: '300 WSM' },
  { id: 132, value: '303 British', abbrev: '303 BRIT' },
  { id: 133, value: '307 Winchester', abbrev: '307 WIN' },
  { id: 134, value: '308 Marlin Express', abbrev: '308 MAR EXP' },
  { id: 135, value: '308 Winchester', abbrev: '308 WIN' },
  { id: 136, value: '32 Winchester Special', abbrev: '32 WIN SPL' },
  { id: 137, value: '32-20 Winchester', abbrev: '32-20 WIN' },
  { id: 138, value: '325 Winchester Short Magnum', abbrev: '325 WSM' },
  { id: 139, value: '33 Nosler', abbrev: '33 NOSLER' },
  { id: 140, value: '338 Federal', abbrev: '338 FED' },
  { id: 141, value: '338 Lapua Magnum', abbrev: '338 LAPUA MAG' },
  { id: 142, value: '338 Norma Magnum', abbrev: '338 NM' },
  { id: 143, value: '338 Marlin Express', abbrev: '338 M E' },
  { id: 144, value: '338 Remington Ultra Magnum', abbrev: '338 REM ULTRA MAG' },
  { id: 145, value: '338 Ruger Compact Magnum', abbrev: '338 RCM' },
  { id: 146, value: '338 Weatherby Rebated Precision Magnum', abbrev: '338 WBY RPM' },
  { id: 147, value: '338 Winchester Magnum', abbrev: '338 WIN MAG' },
  { id: 148, value: '340 Weatherby Magnum', abbrev: '340 WBY MAG' },
  { id: 149, value: '348 Winchester', abbrev: '348 WIN' },
  { id: 150, value: '35 Remington', abbrev: '35 REM' },
  { id: 151, value: '35 Whelen', abbrev: '35 WHELEN' },
  { id: 152, value: '350 Legend', abbrev: '350 LGND' },
  { id: 153, value: '356 Winchester', abbrev: '356 WIN' },
  { id: 154, value: '358 Winchester', abbrev: '358 WIN' },
  { id: 155, value: '360 Buckhammer', abbrev: '360 BHMR' },
  { id: 156, value: '370 Sako Magnum', abbrev: '370 SAKO MAG' },
  { id: 157, value: '375 Holland & Holland Magnum', abbrev: '375 H&H MAG' },
  { id: 158, value: '375 Remington Ultra Magnum', abbrev: '375 REM ULTRA MAG' },
  { id: 159, value: '375 Ruger', abbrev: '375 RUGER' },
  { id: 160, value: '375 Winchester', abbrev: '375 WIN' },
  { id: 161, value: '376 Steyr', abbrev: '376 STEYR' },
  { id: 162, value: '38-40 Winchester', abbrev: '38-40 WIN' },
  { id: 163, value: '38-55 Winchester', abbrev: '38-55 WIN' },
  { id: 164, value: '400 Legend', abbrev: '400 LGND' },
  { id: 165, value: '405 Winchester', abbrev: '405 WIN' },
  { id: 166, value: '416 Remington Magnum', abbrev: '416 REM MAG' },
  { id: 167, value: '416 Rigby', abbrev: '416 RIGBY' },
  { id: 168, value: '416 Ruger', abbrev: '416 RUGER' },
  { id: 169, value: '416 Weatherby Magnum', abbrev: '416 WBY MAG' },
  { id: 170, value: '44 Remington Magnum', abbrev: '44 REM MAG' },
  { id: 171, value: '44-40 Winchester', abbrev: '44-40 WIN' },
  { id: 172, value: '444 Marlin', abbrev: '444 MAR' },
  { id: 173, value: '45-70 Government', abbrev: '45-70 GOVT' },
  { id: 174, value: '450 Bushmaster', abbrev: '450 BM' },
  { id: 175, value: '450 Marlin', abbrev: '450 MARLIN' },
  { id: 176, value: '458 Lott', abbrev: '458 LOTT' },
  { id: 177, value: '458 Winchester Magnum', abbrev: '458 WIN MAG' },
  { id: 178, value: '470 Nitro Express', abbrev: '470 NE' },
  { id: 179, value: '500 Nitro Express 3”', abbrev: '500 NE 3”' },
];

export const CARTRIDGE_MAP_FULL_TO_ABBR = CARTRIDGES.reduce((acc, item) => {
  acc[item.value] = item.abbrev;
  return acc;
}, {});

export const getCartridgeAbbrev = (fullName) => {
  if (!fullName) return '';
  const key = String(fullName).trim();
  return CARTRIDGE_MAP_FULL_TO_ABBR[key] || key;
};


